import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
          click: {
            //refresh: 'refresh',
            galerie: 'toggleImage',
            append: 'append',
            remove: 'remove',
          },
          change: {
            calculEvenementPrice: 'calculEvenementPrice',
            toggleDonation: 'toggleDonation',
            calculRepartition: 'calculRepartition',
          },
        }

        this.ajaxurl = '/wp/wp-admin/admin-ajax.php';
    }

    init() {

    }

    /*refresh(e) {
      const target = e.currentTarget;
      const id = target.getAttribute('data-id');
      var container = document.querySelector('.b-produits-listing_produits');
      var counter = document.querySelector('.b-produits-listing_counter');
      jQuery.ajax({
        url: this.ajaxurl,
        type: 'POST',
        data: {'action': 'refresh_produits', 'term_id': id},
        success: function( response ){
          container.innerHTML = response.content;
          counter.innerHTML = response.count;
        },
      });

      this.call('update', false, 'Scroll'); // update Locomotive Scroll
    }*/

    toggleImage(e) {
      const currentTarget = e.currentTarget;
      const src = currentTarget.getAttribute('src');
      const alt = currentTarget.getAttribute('alt');
      const target = this.$('target')[0];
      target.setAttribute('src', src);
      target.setAttribute('alt', alt);
      var items = document.querySelector('.c-product_gallery_item');
      items.forEach(element => element.classList.remove('is-active'));
      currentTarget.classList.add('is-active');
    }

    calculEvenementPrice() {
      const form = $('form.cart');
      jQuery.ajax({
        url: this.ajaxurl,
        type: 'POST',
        // data: {'action': 'calcul_evenement_price', 'data': form.serialize()},
        data: form.serialize(),
        success: function( response ){
          form.find('#total_evenement').val(response.total);
          form.find('#total_evenement_display').html(response.total_display);
          if(response.addtocart) {
            form.find('button[type="submit"]').removeClass('-disabled').removeAttr('disabled');
          }else {
            form.find('button[type="submit"]').addClass('-disabled').attr('disabled', true);
          }
        },
      });
    }

    toggleDonation(e) {
      let el = e.currentTarget;
      if(el.value == "Autre") {
        document.getElementById('donation_wrap').classList.remove('is-hidden');
      }else {
        document.getElementById('donation_wrap').classList.add('is-hidden');
      }
    }

    // append(e) {
    //   const el = e.currentTarget;
    //   const template = el.getAttribute('data-template');
    //   const target = el.getAttribute('data-target');
    //   const data = {'entree_adulte': $('#entree_adulte').val(), 'entree_enfant': $('#entree_enfant').val()};
    //   jQuery.ajax({
    //     url: this.ajaxurl,
    //     type: 'POST',
    //     data: {'action': 'append', 'template': template, 'data': data},
    //     success: function( response ){
    //       $(target).html(response.content);
    //     },
    //   });
    // }

    append(e) {
      const $this = this;
      const el = e.currentTarget;
      const template = el.getAttribute('data-template');
      const target = el.getAttribute('data-target');
      let params = null;
      let calcul = false;
      if(el.getAttribute('data-params')) {
        params = JSON.parse(el.getAttribute('data-params'));
      }
      if(el.getAttribute('data-calcul')) {
        calcul = true;
      }
      jQuery.ajax({
        url: this.ajaxurl,
        type: 'POST',
        data: {'action': 'append', 'template': template, 'data': params},
        dataType: 'json',
        success: function( response ){
          $(target).append(response.content);
          if(calcul) {
            $this.calculEvenementPrice();
          }
        },
      });
    }


    calculRepartition(e) {
      const el = e.currentTarget;
      const val = $(el).val();
      const target = $(el).attr('data-target');
      if(val >= 0 && val <= 100) {
        $(target).val(Number(100 - val));
      }
      if(val < 0) {
        $(el).val(0);
        $(target).val(100);
      }
      if(val > 100) {
        $(el).val(100);
        $(target).val(0);
      }
    }

    remove(e) {
      const el = e.currentTarget;
      let targetContainerName = $(el).data('target');
      let targetContainer = $('[data-remove="' + targetContainerName + '"]');
      targetContainer.remove();
      if(el.getAttribute('data-calcul')) {
        this.calculEvenementPrice();
      }
    }

}


